import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
    fonts: {
        heading: 'GerTT, sans-serif',
        body: 'Open Sans'
      },
    styles: { 
        global: {
            'html':{
                '--flow-space': 'var(--chakra-space-5)',
                '--flow-lh': 'var(--chakra-lineHeights-7)',
            },
            '.flow > * + *': {
                mt: 'var(--flow-space)',
            },
            'h1, h2, h3, h4': {
                textTransform: 'uppercase',
                '--flow-space': 'var(--chakra-space-10)',
            },
            h3: {
                fontSize: 'var(--chakra-fontSizes-2xl)',
            },
            a: {
                textDecoration: 'underline',
            },
            '.flow': {
                p: {
                    lineHeight: 'var(--flow-lh)',
                },
                'h2 + p': {
                    '--flow-space': 'var(--chakra-space-2)',
                },
                'h3 + p': {
                    '--flow-space': 'var(--chakra-space-1)',
                },
                'h2 + h3': {
                    '--flow-space': 'var(--chakra-space-3)',
                },
                'h2 + .chakra-container': {
                    '--flow-space': '0',
                },
            },
            '.is-tall': {
                height:'350px',
            },
            '.is-medium': {
                height:'414px',
                width:'552px'
            },
            '.two-column': {
                height: ['300px', '330px', '414px'],
                width: ['400px', '440px', '552px']
            },
            '.three-column': {
                height: ['300px', '330px', '271px'],
                width: ['400px', '440px', '362px']
            },
            '.site-nav, .site-nav__child, .mobile-nav': {
                'list-style': 'none',
            },
            '.careers .chakra-popover__popper .chakra-popover__content .site-nav__sub': {
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            }
        }
      }
})

export default theme